import cometBrown from "../../assets/img/comet_brown.png";
// Every section's artwork is static — nothing in the API carries it. One flat
// file per section: the silver one already has the bronze star drawn behind it,
// matching the merged silver+bronze section it links to.
import starGold from "../../assets/img/main_star_gold.png";
import starsSilverBronze from "../../assets/img/main_stars_silver_bronze.png";
import { useSiteData } from "../../contexts/SiteDataContext";
import { useLocale } from "../../i18n/LocaleContext";
import { useLocalized } from "../../i18n/localized";

function MainPageVpns() {
  const { siteData } = useSiteData();
  const { t } = useLocale();
  const text = useLocalized();
  const { ratingList } = siteData;

  if (!ratingList) return;

  // Categories are identified by their canonical tier; the name match is a
  // fallback for data where tiers are not assigned yet. Renaming a category
  // in the admin must not break this page.
  const vpnsBest =
    ratingList.find((item) => item.tier === "gold") ??
    ratingList.find((item) => item.name === "Лучшие VPN");
  // Silver is the public "хорошие VPN" section — bronze rides inside it on the
  // rating page (mergeGoodTiers), so it gets no block of its own here.
  const vpnsGood =
    ratingList.find((item) => item.tier === "silver") ??
    ratingList.find((item) => item.name === "Серебро");
  const vpnsOther =
    ratingList.find((item) => item.tier === "other") ??
    ratingList.find((item) => item.name === "Прочие VPN");

  return (
    <section className="py-[4rem] md:py-[8.5625rem]">
      {vpnsBest ? (
        <div className="container-sm mx-auto md:mb-32 mb-16 2xl:px-0 px-3">
          <div className="flex justify-between gap-0 md:gap-[4rem] lg:gap-[8.75rem]">
            <div className="order-1">
              <div className="md:text-5xl xs:text-3xl font-extrabold text-dark mb-5">
                {text(vpnsBest, "name")}
              </div>
              <div className="text-dark md:text-2xl xs:text-xl mb-9">
                <div
                  dangerouslySetInnerHTML={{
                    __html: text(vpnsBest, "description"),
                  }}
                />
              </div>
              <a
                href={`/rating#rating-section-${vpnsBest.order}`}
                className="button block md:inline-block bg-yellow text-sm md:text-2xl font-black leading-0 rounded-lg text-center py-4 px-12 md:py-6 text-white"
                data-umami-event="Main Page Best VPN Click"
              >
                {t("main.viewRating")}
              </a>
            </div>
            <div className="w-[16rem] order-2 flex-shrink-0 hidden md:block mt-12">
              <img
                src={starGold}
                alt="VPN"
                loading="lazy"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      ) : null}

      {vpnsGood ? (
        <div className="container-sm mx-auto md:mb-32 mb-16 2xl:px-0 px-3">
          <div className="flex justify-between items-center md:gap-[4rem] lg:gap-[8.75rem]">
            <div className="order-2">
              <div className="md:text-5xl xs:text-3xl font-extrabold text-dark mb-5">
                {text(vpnsGood, "name")}
              </div>
              <div className="text-dark md:text-2xl xs:text-xl mb-9">
                <div
                  dangerouslySetInnerHTML={{
                    __html: text(vpnsGood, "description"),
                  }}
                />
              </div>
              <a
                href={`/rating#rating-section-${vpnsGood.order}`}
                className="button block md:inline-block bg-yellow text-sm md:text-2xl font-black leading-0 rounded-lg text-center py-4 px-12 md:py-6 text-white"
                data-umami-event="Main Page Silver VPN Click"
              >
                {t("main.viewRating")}
              </a>
            </div>
            <div className="w-[20rem] order-1 flex-shrink-0 hidden md:block">
              <img
                src={starsSilverBronze}
                alt="VPN"
                loading="lazy"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      ) : null}

      {vpnsOther ? (
        <div className="container-sm mx-auto md:mb-32 mb-16 2xl:px-0 px-3">
          <div className="flex justify-between items-center md:gap-[4rem] lg:gap-[8.75rem]">
            <div className="order-1">
              <div className="md:text-5xl xs:text-3xl font-extrabold text-dark mb-5">
                {text(vpnsOther, "name")}
              </div>
              <div className="text-dark md:text-2xl xs:text-xl mb-9">
                <div
                  dangerouslySetInnerHTML={{
                    __html: text(vpnsOther, "description"),
                  }}
                />
              </div>
              <a
                href={`/rating#rating-section-${vpnsOther.order}`}
                className="button block md:inline-block  bg-transparent border-[0.1875rem] border-dark-2 text-dark-2 text-sm md:text-2xl font-black leading-0 rounded-lg text-center py-4 px-12 md:py-6"
                data-umami-event="Main Page Other VPN Click"
              >
                {t("main.viewRating")}
              </a>
            </div>
            <div className="w-[21.8125rem] order-2 flex-shrink-0 hidden md:block">
              <img
                src={cometBrown}
                alt="VPN"
                loading="lazy"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default MainPageVpns;
